
import { Toast } from "vant";
import Header from "@/components/header/header.vue";
import { onMounted, inject, reactive, ref, toRefs, isReactive } from "vue";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";
export default {
  components: {
    Header,
  },
  setup() {
    const $http: any = inject("$http");
    const router = useRouter();
    const route = useRoute();
    const product = reactive({
      size: 10,
      page: 1,
    });
    const active = ref(0);
    const finished = ref(false);
    const loading = ref(false);
    const onLoad = async () => {
      get_coins_list();
    };
    let CoinsData: any = reactive({
      obj: [],
    });
    let coins_total = ref(route.query.coins_total?route.query.coins_total:0)
     const onClick = () => {
        CoinsData.obj = []
        product.page = 1;
        get_coins_list()
     }
     //watch监听
        // watch(()=>active,(val:any)=>{
        // })
    const get_coins_list = async () => {
      const res = await $http.get_coins_list({
        size: product.size,
        page: product.page,
        use_type:active.value
      });
      loading.value = true;
      if (res.code === 200) {
        product.page += 1;
        CoinsData.obj = CoinsData.obj.concat(res.data);
        if (res.data.length < product.size) {
          finished.value = true;
        }
        loading.value = false;
      }
    };

    return {
      CoinsData,
      loading,
      finished,
      onLoad,
      active,
      onClick,
      coins_total,
    };
  },
};
